"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = format;
function format(Component) {
  Component.prototype.getValueLink = function (_props) {
    var props = _props || this.props;
    return props.valueLink || {
      value: props.value,
      requestChange: props.onChange
    };
  };
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-datepicker/lib/utils/valueLink.js
 ** module id = 1051
 ** module chunks = 0
 **/